import React from 'react'
import { TaskButton } from './taskButton'
import { actionCreators } from '@/store/myTasks'
import connect from 'react-redux/es/connect/connect'
import { workflowTaskStatus } from '@/enums/workflowTaskStatus'

let TaskResponseButtons = (props) => {
  const { useActiveTask, closeTask, activeTask, closing, disabled, task } = props
  let buttons
  if (useActiveTask) {
    buttons = activeTask.data && activeTask.data.responseButtons
  } else {
    buttons = task.data && task.data.responseButtons
  }
  if (!buttons || buttons.length === 0) return null
  return <React.Fragment>
    {buttons.map((b, i) => <TaskButton
      key={i}
      {...b}
      onClick={result => closeTask(activeTask.id, result)}
      disabled={closing}
      onlyShow={disabled}
    />)}
  </React.Fragment>
}

const mapStateToProps = (state, ownProps) => {
  const { closing } = state.myTasks
  const { activeTask } = state.myActiveTask
  const mappedState = {
    closing,
    activeTask,
    show: activeTask && activeTask.status === workflowTaskStatus.enum.Active
  }
  return {
    ...mappedState,
    ...ownProps
  }
}

const mapDispatchToProps = {
  closeTask: actionCreators.closeTask
}

TaskResponseButtons = connect(mapStateToProps, mapDispatchToProps)(TaskResponseButtons)

export {
  TaskResponseButtons
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/responseButtons.js